const withDefaults = (props, variantOverrides = {}) => ({
  hideScrollbar: true,
  scrollHint: 0,
  scrollInterval: undefined,
  scrollStep: 'full-width',
  suggestiveFade: false,
  scrollSnapAlign: 'center',
  ...variantOverrides,
  ...props
});
export const getVariantOptions = (variant, options) => ({
  default: () => withDefaults(options),
  spotlight: () => withDefaults(options)
})[variant]();
export const getVariantOverrides = variant => ({
  default: () => ({}),
  spotlight: () => ({
    maxRows: 1,
    maxColumns: 1
  })
})[variant]();